export default __webpack_public_path__ + "static/media/loading_gif.c1b8565f.gif";